module.exports = require("es6-error");


//////////////////
// WEBPACK FOOTER
// external "es6-error"
// module id = 163
// module chunks = 0